import { render, staticRenderFns } from "./DicomCutReportDlg.vue?vue&type=template&id=bc1b245e&scoped=true&"
import script from "./DicomCutReportDlg.vue?vue&type=script&lang=js&"
export * from "./DicomCutReportDlg.vue?vue&type=script&lang=js&"
import style0 from "./DicomCutReportDlg.vue?vue&type=style&index=0&id=bc1b245e&prod&scoped=true&lang=css&"
import style1 from "./DicomCutReportDlg.vue?vue&type=style&index=1&id=bc1b245e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1b245e",
  null
  
)

export default component.exports